import { FirstOption, Option } from "check-password-strength";

export const LOGIN_ERRORS: Record<number, string> = {
  1: "Password or email is incorrect, check your credentials and try again.",
  2: "You have exceeded the number of login attempts. Please try again later.",
  3: "Your account has been suspended. Please contact your administrator.",
  4: "Your account has been deactivated. Please contact your administrator.",
  7: "Your password has expired. Please reset your password to continue.",
  0: "An unexpected error occurred. Please try again later.",
};

export const PASSWORD_STRENGTH_OPTIONS = [
  {
    id: 0,
    value: "Too weak",
    minDiversity: 0,
    minLength: 0,
  },
  {
    id: 1,
    value: "Weak",
    minDiversity: 2,
    minLength: 6,
  },
  {
    id: 2,
    value: "Medium",
    minDiversity: 4,
    minLength: 8,
  },
  {
    id: 3,
    value: "Strong",
    minDiversity: 4,
    minLength: 12,
  },
] as [FirstOption<string>, ...Option<string>[]];
